/**
 * 封装axios
 */

import axios from 'axios';
import { Toast } from 'antd-mobile';
// import { getStorage } from "../common/util"
// let FormalChecked = getStorage('FormalChecked')
// let TestChecked = getStorage('TestChecked')
// let service = {}
//
// if (FormalChecked == true && TestChecked == false) {
//     service = axios.create({
//          baseURL:'https://app-uat.zkgbgroup.com/wlpt',
//         timeout: 20000
//     })
//
// } else {
//     service = axios.create({
//          baseURL: 'https://app-uat.zkgbgroup.com/wlpt',
//          timeout: 20000
//     })
//
// }
// axios默认配置
const service = axios.create({
    // baseURL: 'https://app-uat.zkgbgroup.com/wlpt',
    baseURL:'https://app.zkgbgroup.com/',
    timeout: 20000
})
service.defaults.headers.post['Content-Type'] = 'application/json';

let httpCode = {
    400: '请求参数错误',
    401: '权限不足, 请重新登录',
    403: '服务器拒绝本次访问',
    404: '请求资源未找到',
    500: '内部服务器错误',
    501: '服务器不支持该请求中使用的方法',
    502: '网关错误',
    504: '网关超时'
}

// 添加请求拦截器
service.interceptors.request.use(config => {
    config.headers['token'] = sessionStorage.getItem('token') || '';
    Toast.loading('Loading...', 0);
    config.data = JSON.stringify(config.data);
    return config;
}, error => {
    return Promise.reject(error);
})

// 添加响应拦截器
service.interceptors.response.use(response => {
    Toast.hide();
    if (response.status === 200 || response.statusText === 'OK') {
        return Promise.resolve(response.data);
    } else {
        Toast.fail('响应超时！', 2);
        return Promise.reject(response.data.message);
    }
}, error => {
    Toast.hide();
    if (error.response) {
        let tips = error.response.status in httpCode ? httpCode[error.response.status] : error.response.data.message;
        Toast.fail(tips);
        return Promise.reject(error);
    } else {
        Toast.fail('请求超时，请刷新重试！', 2);
        return Promise.reject('请求超时，请刷新重试!');
    }
})

// 统一封装get请求
export const get = (url, params, config = {}) => {
    return new Promise((resolve, reject) => {
        service({
            method: 'get',
            url: url + params,
            ...config
        }).then(response => {
            if (response.statuscode === "0") {
                resolve(response);
            } else {
                Toast.fail(response.errinfo, 2);
                reject(response.errinfo);
            }
        }).catch(error => {
            Toast.fail(error, 2);
            reject(error);
        })
    })
}

// 统一封装post请求
export const post = (url, data, config = {}) => {
    return new Promise((resolve, reject) => {
        service({
            method: 'post',
            url,
            data,
            ...config
        }).then(response => {
            if (response.statuscode === "0") {
                resolve(response);
            } else {
                Toast.fail(response.errinfo, 2);
                reject(response.errinfo);
            }
        }).catch(error => {
            Toast.fail(error, 2);
            reject(error);
        })
    })
}

// 特殊post请求
export const newPost = (url, data, config = {}) => {
    return new Promise((resolve, reject) => {
        service({
            method: 'post',
            url,
            data,
            ...config
        }).then(response => {
            if (response.success) {
                resolve(response);
            } else {
                Toast.fail(response.errinfo, 2);
                reject(response.errinfo);
            }
        }).catch(error => {
            Toast.fail(error, 2);
            reject(error);
        })
    })
}
